import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { LockService } from '../services/lock.service';

@Component({
    selector: 'app-pin-dialog',
    imports: [CommonModule, MatDialogModule, MatButtonModule],
    template: `
    <div class="pin-dialog">
      <h2>Enter PIN</h2>
      <div class="pin-display">
        <div class="pin-dot" *ngFor="let dot of pinDots" [class.filled]="dot"></div>
      </div>
      <div class="error" *ngIf="error">Invalid PIN</div>
      <div class="numpad">
        <button mat-button (click)="addDigit('1')">1</button>
        <button mat-button (click)="addDigit('2')">2</button>
        <button mat-button (click)="addDigit('3')">3</button>
        <button mat-button (click)="addDigit('4')">4</button>
        <button mat-button (click)="addDigit('5')">5</button>
        <button mat-button (click)="addDigit('6')">6</button>
        <button mat-button (click)="addDigit('7')">7</button>
        <button mat-button (click)="addDigit('8')">8</button>
        <button mat-button (click)="addDigit('9')">9</button>
        <button mat-button (click)="clearPin()">Clear</button>
        <button mat-button (click)="addDigit('0')">0</button>
        <button mat-button (click)="submitPin()">Enter</button>
      </div>
    </div>
  `,
    styles: [`
    .pin-dialog {
      padding: 20px;
      text-align: center;
      user-select: none;
    }
    .pin-display {
      display: flex;
      justify-content: center;
      gap: 10px;
      margin: 20px 0;
    }
    .pin-dot {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 2px solid #ccc;
      transition: background-color 0.2s;
    }
    .pin-dot.filled {
      background-color: #666;
    }
    .error {
      color: red;
      margin: 10px 0;
    }
    .numpad {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 10px;
      max-width: 300px;
      margin: 0 auto;
    }
    .numpad button {
      height: 60px;
      font-size: 24px;
      min-width: 0;
    }
    h2 {
      margin-bottom: 20px;
    }
  `]
})
export class PinDialogComponent {
  pin: string = '';
  pinDots: boolean[] = [false, false, false, false];
  error: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<PinDialogComponent>,
    private lockService: LockService
  ) {}

  addDigit(digit: string) {
    if (this.pin.length < 4) {
      this.pin += digit;
      this.updatePinDots();
      if (this.pin.length === 4) {
        this.submitPin();
      }
    }
  }

  clearPin() {
    this.pin = '';
    this.updatePinDots();
    this.error = false;
  }

  private updatePinDots() {
    this.pinDots = this.pin.split('').map(() => true);
    while (this.pinDots.length < 4) {
      this.pinDots.push(false);
    }
  }

  submitPin() {
    if (this.pin.length === 4) {
      if (this.lockService.unlock(this.pin)) {
        this.dialogRef.close(true);
      } else {
        this.error = true;
        this.clearPin();
      }
    }
  }
}